/**
 * VisualGest — Landing (Fase O.8 — 2026-05-14).
 *
 * Ponto de entrada do conector VisualGest na web actual. Dá acesso às
 * 3 áreas de consulta/gestão; a configuração da ligação vive no painel
 * VisualGest dentro de /settings.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const CARDS = [
    {
        path: "/visualgest-invoices",
        icon: "bi-receipt",
        titleKey: "visualgest_invoices_title",
        titleDefault: "Facturas emitidas",
        descKey: "visualgest_invoices_desc",
        descDefault: "Documentos emitidos no VisualGest. Descarregar PDF e reenviar por email.",
    },
    {
        path: "/visualgest-stock-alerts",
        icon: "bi-exclamation-triangle",
        titleKey: "visualgest_stock_alerts_title",
        titleDefault: "Anulações em retenção",
        descKey: "visualgest_stock_alerts_desc",
        descDefault: "Anulações comunicadas pelo VisualGest à espera de decisão (repor / ignorar stock).",
    },
    {
        path: "/visualgest-operation-log",
        icon: "bi-list-columns",
        titleKey: "visualgest_operation_log_title",
        titleDefault: "Log de operações",
        descKey: "visualgest_operation_log_desc",
        descDefault: "Registo das chamadas entre TP e VisualGest. Útil para diagnóstico.",
    },
];

export default function VisualGestLanding() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isApp = Number(localStorage.getItem("isApp"));

    const handleBack = () => {
        navigate(isApp === 1 ? "/back-app" : "/settings");
    };

    return (
        <div>
            <section className="content-header">
                <div className="container-fluid container-custom-height-new">
                    <div className="row mb-2">
                        <div className="col-sm-12 d-flex align-items-center">
                            <button
                                type="button"
                                className="next-button btn btn-secondary"
                                onClick={handleBack}
                            >
                                <i className="bi bi-arrow-left"></i> {t("back", { defaultValue: "Voltar" })}
                            </button>
                            <h1 className="page-title ms-auto mb-2">VisualGest</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="container-fluid container-custom-height-new">
                    <div className="row">
                        {CARDS.map((c) => (
                            <div className="col-md-4" key={c.path}>
                                <div
                                    className="card fuelCard"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(c.path)}
                                >
                                    <div className="card-body text-center" style={{ padding: 28 }}>
                                        <i className={`bi ${c.icon}`} style={{ fontSize: 38, color: "#81bb42" }}></i>
                                        <h5 className="mt-3 mb-2">
                                            {t(c.titleKey, { defaultValue: c.titleDefault })}
                                        </h5>
                                        <p className="text-muted m-0">
                                            {t(c.descKey, { defaultValue: c.descDefault })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
